import { render, staticRenderFns } from "./collecteur_classement.vue?vue&type=template&id=54419ef8"
import script from "./collecteur_classement.vue?vue&type=script&lang=js"
export * from "./collecteur_classement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports